import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) => {
  return data.map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType, loadOptions, editable, note }) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType,
      note: note,
      loadOptions,
      editable,
    })
  );
};

export const fields: any = {
  centralizedPromotions: mapFields(drilldownData["centralizedPromotions"]),
};
